import type { StepIconsDto } from '@nsb/core';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { api, type ApiError } from '../../api.ts';

export const stepIconsKey = ['process', 'step-icons'];

/**
 * The tree's painted pictures, one a step (Jason, 2026-10-03: "each node
 * should have an on-brand image icon"; "a real watercolor or simplified visual
 * for the nodes is helpful for quickly seeing what is happening"), by the
 * step's key, for the drawing. While some are being painted it looks again
 * now and then.
 */
export function useStepIcons() {
  const q = useQuery<StepIconsDto, ApiError>({
    queryKey: stepIconsKey,
    queryFn: () => api<StepIconsDto>('/process/step-icons'),
    staleTime: 60_000,
    refetchInterval: (query) => (query.state.data?.painting ? 15_000 : false),
  });
  const urls = useMemo(() => new Map((q.data?.icons ?? []).map((i) => [i.key, i.url])), [q.data]);
  return { data: q.data, urls };
}

export type StepIcons = ReturnType<typeof useStepIcons>;
